import http from '@/utils/http'

/**
 * 添加开通城市
*/
export function addCity(data) {
    return http({
        method: 'post',
        url: '/system/sysOpenCity/add',
        data
    })
}

/**
 * 删除开通城市
*/
export function delCity(data) {
    return http({
        method: 'post',
        url: '/system/sysOpenCity/delete',
        params: data
    })
}

/**
 * 开通城市详情
*/
export function getCityDetail(params) {
    return http({
        method: 'get',
        url: '/system/sysOpenCity/find',
        params
    })
}

/**
 * 开通城市分页列表
*/
export function getCityList(params) {
    return http({
        method: 'get',
        url: '/system/sysOpenCity/paging',
        params
    })
}

/**
 * 用户登录
*/
export function editCity(data) {
    return http({
        method: 'post',
        url: '/system/sysOpenCity/update',
        data
    })
}